import React, { useEffect } from "react";
import { Global } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../components/SeoHead';
import FourOhFour from '../components/FourOFour';
import { useRouter } from 'next/router';

export default function Fourohfour({ global }) {

	const router = useRouter();
	const path = router.asPath.split("/")[1];

	useEffect(() => {
		if (path === "jobs") {
			router.push("/jobs")
		}
	}, [path]);
	
	return (
		<>
			<SeoHead
				page_name={`404 - This page is not found | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
			/>
			<FourOhFour
				global={global}
				pathPrefix={`404_page.fourofour`}
				customClass={``}
			/>
		</>
	)
}

export async function getStaticProps({ params }) {
	const global = (await Global()).toJson();

	return { props: { global } };
}
